import * as CONST from '../ActionTypes';

const initialState = {
  warehouses: {},
  warehouse: {},
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function warehouse(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 保管場所の一覧取得
    // -----------------
    case CONST.GET_WAREHOUSE_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          warehouses: action.payload,
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.GET_WAREHOUSE_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          warehouses: {},
          isSuccess: false,
          isFailure: false,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 保管場所の詳細取得
    // -----------------
    case CONST.GET_WAREHOUSE_DETAILS_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          warehouse: action.payload,
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.GET_WAREHOUSE_DETAILS_FAILURE:
      return Object.assign(
        {},
        state,
        {
          warehouse: {},
          isSuccess: false,
          isFailure: false,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 保管場所の追加
    // -----------------
    case CONST.CREATE_WAREHOUSE_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.CREATE_WAREHOUSE_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 保管場所の追加
    // -----------------
    case CONST.UPDATE_WAREHOUSE_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.UPDATE_WAREHOUSE_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    case CONST.CLEAR_WAREHOUSE_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: action.payload,
        },
      );
    default:
      return state;
  }
}

export default warehouse;
